import React, {useState} from 'react'
import './styles/global.scss'
import './styles/intro.scss'
import blueBlob from './assets/blue-blob.png'
import yellowBlob from './assets/yellow-blob.png'
import QuestionList from './components/QuestionsList'

function App() {
  const [gameStarted, setGameStarted] = useState(false)
  const [showNoQuestionsError, setShowNoQuestionsError] = useState(false)
  const [gameOptions, setGameOptions] = useState(
		{
			category: "",
			difficulty: "",
			type: ""
		}
	)

	function handleGameStart() {
    setGameStarted(prevState => !prevState)
  }

  function handleNoQuestionsError(boolean) {
    setShowNoQuestionsError(boolean)
  }
  
  function handleChange(event){
		const { name, value } = event.target

		setGameOptions(prevGameOptions => {
			return {
				...prevGameOptions,
				[name]: value
			}
		})
	}
  return (
    <main className="main">
      <img className="yellow-blob" src={yellowBlob} alt="yellow blob"/> 

      {
        gameStarted 
          ?
					<section className="game-container">
						<QuestionList
              gameOptions={gameOptions}
							handleGameStart={handleGameStart}
              handleNoQuestionsError={handleNoQuestionsError}
            />
					</section>
          :
          <section className="intro">
            <h1 className="intro__title">Quizzical</h1>
            <h3 className="intro__subtitle">Pick your categories and get quizzed about them</h3>

            {showNoQuestionsError &&
							<h2 className="noQuestions-text">
								Oops! We couldn't find any questions with these options!
							</h2>
						}

            <div className="intro__categories">
              <div className="intro-categories__container">
                <label className="intro-categories__label" htmlFor="category">Category:</label>
                <select
                  name="category"
                  id="category"
                  className="intro-categories__select"
                  value={gameOptions.category}
                  onChange={handleChange}
                >
                  <option value="">Any Category</option>
                  <option value="9">General Knowledge</option>
                  <option value="10">Entertainment: Books</option>
                  <option value="11">Entertainment: Film</option>
                  <option value="12">Entertainment: Music</option>
                  <option value="13">Entertainment: Musicals &amp; Theatres</option>
                  <option value="14">Entertainment: Television</option>
                  <option value="15">Entertainment: Video Games</option>
                  <option value="16">Entertainment: Board Games</option>
                  <option value="17">Science &amp; Nature</option>
                  <option value="18">Science: Computers</option>
                  <option value="19">Science: Mathematics</option>
                  <option value="20">Mythology</option>
                  <option value="21">Sports</option>
                  <option value="22">Geography</option>
                  <option value="23">History</option>
                  <option value="24">Politics</option>
                  <option value="25">Art</option>
                  <option value="26">Celebrities</option>
                  <option value="27">Animals</option>
                  <option value="28">Vehicles</option>
                  <option value="29">Entertainment: Comics</option>
                  <option value="30">Science: Gadgets</option>
                  <option value="31">Entertainment: Japanese Anime &amp; Manga</option>
                  <option value="32">Entertainment: Cartoon &amp; Animations</option>
                </select>
              </div>
                    
              <div className="intro-categories__container">
                <label className="intro-categories__label" htmlFor="difficulty">Difficulty:</label>
                <select
                  name="difficulty"
                  id="difficulty"
                  className="intro-categories__select"
                  value={gameOptions.difficulty}
                  onChange={handleChange}
                >
                  <option value="">Any Difficulty</option>
                  <option value="easy">Easy</option>
                  <option value="medium">Medium</option>
                  <option value="hard">Hard</option>
                </select>
              </div>
                    
              <div className="intro-categories__container">
                <label className="intro-categories__label" htmlFor="type">Type:</label>
                <select
                  name="type"
                  id="type"
                  className="intro-categories__select"
                  value={gameOptions.type}
                  onChange={handleChange}
                >
                  <option value="">Any Type</option>
                  <option value="multiple">Multiple Choice</option>
                  <option value="boolean">True / False</option>
                </select>
              </div>
            </div> 

            <button
              className="btn"
              onClick={handleGameStart}
            >
              Start quiz
            </button>
          </section>
      }
      <img className="blue-blob" src={blueBlob} alt="blue blob"/>
    </main>
  )
}

export default App
